import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../../data/siteConfig';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToMap = () => {
    const mapElement = document.querySelector('#map');
    if (mapElement) {
      mapElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer" id="map">
      <div className="container">
        {/* Map Section */}
        <div className="footer__map">
          <div className="map-container">
            <h3>Find Us</h3>
            <div className="address">
              <p>{siteConfig.contact.address.full}</p>
            </div>
            
            {/* Google Maps Embed */}
            <div className="map-embed">
              <iframe
                src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dOMB0A2q-0M4qY&q=${encodeURIComponent(siteConfig.contact.address.full)}`}
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Golden Pour Location"
              />
            </div>
            
            <a 
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(siteConfig.contact.address.full)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Get Directions
            </a>
          </div>
        </div>

        {/* Footer Content */}
        <div className="footer__content">
          {/* Brand Section */}
          <div className="footer__brand">
            <h3 className="footer__brand-name">{siteConfig.brand.name}</h3>
            <p className="footer__tagline">{siteConfig.brand.tagline}</p>
            <p className="footer__description">{siteConfig.brand.description}</p>
          </div>

          {/* Quick Links */}
          <div className="footer__links">
            <h4>Quick Links</h4>
            <ul>
              {siteConfig.navigation.map((item) => (
                <li key={item.path}>
                  {item.path.startsWith('#') ? (
                    <button 
                      onClick={scrollToMap}
                      className="footer__link"
                    >
                      {item.name}
                    </button>
                  ) : (
                    <Link to={item.path} className="footer__link">
                      {item.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer__contact">
            <h4>Contact</h4>
            <div className="contact-item">
              <strong>Address:</strong>
              <p>{siteConfig.contact.address.full}</p>
            </div>
            {siteConfig.contact.phone && (
              <div className="contact-item">
                <strong>Phone:</strong>
                <a href={`tel:${siteConfig.contact.phone}`}>{siteConfig.contact.phone}</a>
              </div>
            )}
            {siteConfig.contact.email && (
              <div className="contact-item">
                <strong>Email:</strong>
                <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
              </div>
            )}
          </div>

          {/* Hours */}
          <div className="footer__hours">
            <h4>Hours</h4>
            {siteConfig.hours.status === 'opening_soon' ? (
              <p className="opening-soon">{siteConfig.hours.message}</p>
            ) : (
              <div className="hours-list">
                {Object.entries(siteConfig.hours.regular).map(([day, hours]) => (
                  <div key={day} className="hours-item">
                    <span className="day">{day.charAt(0).toUpperCase() + day.slice(1)}</span>
                    <span className="time">
                      {hours.closed ? 'Closed' : `${hours.open} - ${hours.close}`}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer__bottom">
          <div className="footer__legal">
            <p>&copy; {currentYear} {siteConfig.brand.companyName}. All rights reserved.</p>
            <div className="footer__legal-links">
              {siteConfig.footerMenu.map((item) => (
                <Link key={item.path} to={item.path} className="footer__legal-link">
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;